import { RESET } from '../actionTypes';
import { createContactModalActions } from '../reducer';

export default () => createContactModalActions[RESET]();
